import * as React from 'react';
import {InfoWrapper} from '~/components/Layout';
import {Progress} from '~/components/Progress';


export const InitializingView = () => <InfoWrapper><Progress/></InfoWrapper>;
